export const handleSaveLogError = (screen: string, error: unknown) => {
    return console.log({
        screen,
        error,
    })
}